export type Library = 'appearances' | 'patterns' | 'colors' | 'finishes';
export type PaletteKind = 'pattern' | 'finish';
export type PaletteLibrary = 'patterns' | 'finishes';
export type ActiveFilter = 'true' | 'false' | 'true,false';

export const PALETTE_LIBRARY: Record<PaletteKind, PaletteLibrary> = {
  pattern: 'patterns',
  finish: 'finishes',
};

export const LIBRARY_PALETTE: Record<PaletteLibrary, PaletteKind> = {
  patterns: 'pattern',
  finishes: 'finish',
};

export const LIBRARIES: { id: Library; title: string; description: string }[] = [
  { id: 'appearances', title: 'Vzhledy', description: 'Barva, dezén a úprava povrchu modelu' },
  { id: 'patterns', title: 'Dezény', description: 'Paleta dezénů modelu (D1, D2, …)' },
  { id: 'colors', title: 'Barvy', description: 'Paleta barev modelu (B1, B2, …)' },
  {
    id: 'finishes',
    title: 'Úpravy povrchu',
    description: 'Paleta úprav povrchu modelu (P1, P2, …)',
  },
];

export type ColorCategory = 'BA' | 'IM' | 'VL' | 'VI';

export const COLOR_CATEGORIES: { value: ColorCategory; label: string }[] = [
  { value: 'BA', label: 'Barva' },
  { value: 'IM', label: 'Imitace' },
  { value: 'VL', label: 'Vlastní barva materiálu' },
  { value: 'VI', label: 'Vícebarevný vzor' },
];

export interface ColorProperty {
  id: string;
  title: string;
}

export interface AppearanceBase {
  id: string;
  title: string;
  sys_title: string;
  custom_title: string | null;
  hex: string | null;
  is_active: boolean;
}

export interface ModelColor {
  id: string;
  order: number;
  code: string;
  title: string;
  hex: string;
  color_code: string | null;
  category: ColorCategory;
  category_label: string;
  properties: ColorProperty[];
  appearance_count?: number;
  is_active: boolean;
}

export interface ModelColorDetail extends ModelColor {
  appearances: { id: string; title: string }[];
}

export interface ColorDropdownItem {
  id: string;
  code: string;
  title: string;
  hex: string;
}

export interface ModelColorCreateInput {
  model: string;
  title: string;
  hex: string;
  color_code?: string | null;
  category?: ColorCategory;
  properties?: string[];
}

export interface ModelColorPatchInput {
  title?: string;
  hex?: string;
  color_code?: string | null;
  category?: ColorCategory;
  properties?: string[];
  confirm_shared?: boolean;
}

export interface ClassifiedSolutionRef {
  id: string;
  solution_id: string;
  title: string | null;
  image_url: string | null;
  is_active: boolean;
}

export interface PaletteItem {
  id: string;
  order: number;
  code: string;
  title: string;
  custom_title: string | null;
  classified_solution: ClassifiedSolutionRef;
  appearance_count?: number;
  is_active: boolean;
}

export interface PaletteDropdownItem {
  id: string;
  code: string;
  title: string;
}

export interface AppearanceDetail extends AppearanceBase {
  model_color: ModelColor | null;
  model_pattern: PaletteItem | null;
  model_finish: PaletteItem | null;
}

export interface AppearanceComponentRef {
  code: string;
  title: string;
  image_url: string | null;
}

/** Shape of `appearance` on instance-type detail and common-data. */
export interface TypemarkAppearance extends AppearanceBase {
  pattern?: AppearanceComponentRef | null;
  finish?: AppearanceComponentRef | null;
}

export interface AppearanceCreateInput {
  model: string;
  custom_title?: string | null;
  model_color: string;
  model_pattern?: string | null;
  model_finish?: string | null;
}

export interface AppearancePatchInput {
  custom_title?: string | null;
  model_color?: string;
  model_pattern?: string | null;
  model_finish?: string | null;
  is_active?: boolean;
}
